import React from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import * as R from 'ramda'
import { useSelector } from 'react-redux'
import {
  getBookByOriginalId,
  getChapterByBookOriginalIdAndOrder
} from 'modules/books/ducks/selectors'
import { useTranslation } from 'react-i18next'
import { RootReducer } from 'types'

export const HeadingChapter = (): JSX.Element => {
  const { t } = useTranslation()
  const params = useParams()
  const bookId: string = R.propOr('', 'bookId')(params)
  const partOrder: number = R.pipe(R.propOr('', 'partOrder'), Number)(params)
  const chapterOrder: number = R.pipe(
    R.propOr('1', 'chapterOrder'),
    Number
  )(params)

  const chapter = useSelector((state: RootReducer) =>
    getChapterByBookOriginalIdAndOrder(state, bookId, chapterOrder)
  )
  const isFirstPageOfChapter = partOrder === 1

  const book = useSelector(state => getBookByOriginalId(state, bookId))
  const tag = R.propOr('', 'tag', book)
  const headerAbbreviation = R.propOr('', 'header_abbreviation', book)
  const tagColor = R.propOr('', 'tag_colour', book)
  const image = R.propOr(null, 'chapter_heading_image_url', book)
  const chapterTitle: string = R.propOr('', 'title', chapter)

  return isFirstPageOfChapter && image ? (
    <HeadingContainer>
      <BgImage src={image} />
      <HeadingContent>
        <BookTag color={tagColor}>{headerAbbreviation ?? tag}</BookTag>
        <div>
          <ChapterOrder>
            {t('bookViewer.chapter')} {chapterOrder}
          </ChapterOrder>
          <ChapterTitle>{chapterTitle}</ChapterTitle>
        </div>
      </HeadingContent>
    </HeadingContainer>
  ) : (
    <div />
  )
}

export default HeadingChapter

const HeadingContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  min-height: 88px;
`

const BgImage = styled.img`
  width: calc(100% + 10px);
  position: relative;
  left: -10px;
`

const HeadingContent = styled.div`
  position: absolute;
  width: calc(100% + 10px);
  left: -10px;
  top: 0;
  padding: 12px 10px;
  display: flex;
  gap: 24px;
`

const BookTag = styled.div`
  color: ${({ theme, color }) => theme.colors.tags[color].backgroundActive};
  background-color: ${({ theme, color }) =>
    theme.colors.tags[color].background};
  border-radius: 8px;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  height: 64px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  writing-mode: vertical-lr;
  transform: rotate(180deg);
`

const ChapterOrder = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.main.white};
`

const ChapterTitle = styled.div`
  font-weight: 700;
  font-size: 32px;
  line-height: 37px;
  color: ${({ theme }) => theme.colors.main.white};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 560px;
`
